import { FC, useEffect, useState } from 'react'
import { UserTable } from '../UserTable'
import { getProfileFollowers } from '../../services/profileService'

interface IFollowersProps {
  address: string
}

export const Followers: FC<IFollowersProps> = (props: IFollowersProps) => {
  const { address } = props
  const [followers, setFollowers] = useState<any[]>([])

  useEffect(() => {
    if (address) {
      getProfileFollowers(address).then((data) => {
        console.log(data)
        setFollowers(data.items)
      })
    }
  }, [address])

  return <UserTable data={followers} />
}
